import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { RequestStatus } from 'core/domain/Request';
import { signOut } from 'core/utils/signout';
import { PBIExportableReport, PBIReport } from 'managed-analytics/domain/PBIReport';
import { getPBIExportableReports, getPBIReports } from 'managed-analytics/use-cases/getPBIReports';

export function usePBIReports() {
  const [reports, setReports] = useState<Array<PBIReport>>([])
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.Initial)
  const navigate = useNavigate()

  const isLoading = status === RequestStatus.Pending


  const getReports = useCallback(async (config?: AbortController) => {
    setStatus(RequestStatus.Pending)

    try {
      const reports = await getPBIReports(config)
      setReports(reports)
      setStatus(RequestStatus.Done)
    } catch (error: any) {
      if (config?.signal.aborted) return
      if (error.status = '401'){
        await signOut();
        navigate('/');
      } 
      else{
        setStatus(RequestStatus.Error)
      }
      
      setReports([])

      throw error
    }
  }, [navigate])

  return {
    isLoading,
    status,
    reports,
    getReports,
  }
}


export function usePBIExportableReports() {
  const [reports, setReports] = useState<Array<PBIExportableReport>>([])
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.Initial)
  const navigate = useNavigate()

  const isLoading = status === RequestStatus.Pending

  const getExportableReports = useCallback(async (config?: AbortController) => {
    setStatus(RequestStatus.Pending)

    try {
      const reports = await getPBIExportableReports(config)
      setReports(reports)
      setStatus(RequestStatus.Done)
    } catch (error: any) {
      if (config?.signal.aborted) return
      if (error.status = '401'){
        await signOut();
        navigate('/');
      } 
      else{
        setStatus(RequestStatus.Error)
      }
      
      setReports([])

      throw error
    }
  }, [navigate])

  return {
    isLoading,
    status,
    reports,
    getExportableReports,
  }
}